import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function revealFunction() {
  if($(".wp-block-thefuturblocks-list.anim-reveal").length) {

    $(".wp-block-thefuturblocks-list-item").each(function() {
      var self = $(this),
      tl = gsap.fromTo(self, {autoAlpha:0,y:40}, {autoAlpha: 1,y: 0,duration: 0.4});
      var st = ScrollTrigger.create({
        trigger: self,
        start: "+=100 bottom",
        animation: tl
      });
    })
  }
}
$(window).on('load', () => {
  if($('.c-loader').length) {
    gsap.delayedCall(4, function() {
      revealFunction();
    })
  } else {
    gsap.delayedCall(0.4, function() {
      revealFunction();
    })
  }
})